export default __webpack_public_path__ + "static/BannerDraftJsWithImageListWithCharTitle-900590e698bf71c78aae5eac5eb0ce16.jpg";